import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/shared/services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigureGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private myRouter: Router) {
  }

  canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean {

  this.myRouter.navigate(['/dashboard']);
  return false;
}
}
